import * as React from 'react';
// Dependency Imports
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import Highlighter from 'react-highlight-words';
// Utilities, helpers, types
import { AppState } from '../../store';
import DoublePanel, { sortCaret } from '../../components/common/DoublePanel/DoublePanel';
import Header from '../../components/company_operations/ticket-search/Header';
import Details from '../../components/company_operations/ticket-search/Details';
import ImageCounter from '../../components/company_operations/ticket-search/ImageCounter';
//@ts-ignore
//!!r-18-dj
import { useHistory } from 'react-router';
import { useQuery } from '../../utilities/helper';
import axios from 'axios';
import AxiosConfig from '../../utilities/AxiosConfig';
import '../../pages/hr/Employees/Employees.css';
interface IProps {
    userId: string;
    TicketSearchColumns: Array<string> | null | undefined;
}

interface Result {
    Address: string;
    City: string;
    County: string;
    ELMArea: string;
    Excavator: string;
    ImportDate: string | Date;
    ProfitCenterID: number;
    State: string;
    TicketID: number;
    TicketNum: string;
    TicketRevision: string;
}

const splitString = (str: string): any => str.match(/"[^"]*"|\S+/g)
    ? str.match(/"[^"]*"|\S+/g)?.map((m: string) => m.slice(0, 1) === '"' ? m.slice(1, -1) : m)
    : str.split(" ");

const TicketSearch: React.FC<IProps> = (props: IProps) => {
    const { userId } = props;
    const [tableSearchTerm, setTableSearchTerm] = React.useState("" as string);
    const [filteredResults, setFilteredResults] = React.useState([] as Array<Result>);
    const [renderedAmount, setRenderedAmount] = React.useState(250);
    const [matchExact, setMatchExact] = React.useState(false);
    const ticketSearchRef = React.useRef() as any;
    const history: any = useHistory();
    const query: any = useQuery();

    const columns: any = [
        {
            dataField: "ImportDate",
            text: "Import",
            formatter: (cell: any) => dayjs(cell).format("MM/DD/YYYY"),
            sort: true,
            sortCaret: sortCaret,
            headerFormatter: (column: any, colIndex: number, components: any) => {
                //console.log("Rendering Table");
                return (
                    <div className="d-flex align-items-center">
                        {column.text}
                        {components.sortElement}
                    </div>
                )
            },
            headerClasses: "no-wrap"
        },
        {
            dataField: "TicketNum",
            text: "Ticket #",
            formatter: (cell: any, row: any, rowIndex: number, { exact, search }: { exact: boolean, search: string }) =>
                <Highlighter
                    highlightClassName="elm-blue-highlight"
                    searchWords={exact ? [search] : splitString(search)} textToHighlight={cell || ""}
                />,
            formatExtraData: { exact: matchExact, search: tableSearchTerm },
            sort: true,
            sortCaret: sortCaret,
            headerFormatter: (column: any, colIndex: number, components: any) => {
                return (
                    <div className="d-flex align-items-center">
                        {column.text}
                        {components.sortElement}
                    </div>
                )
            },
            headerClasses: "no-wrap"
        },
        {
            dataField: "TicketRevision",
            text: "Rev #",
            formatter: (cell: any, row: any, rowIndex: number, { exact, search }: { exact: boolean, search: string }) =>
                <Highlighter
                    highlightClassName="elm-blue-highlight"
                    searchWords={exact ? [search] : splitString(search)} textToHighlight={cell || ""}
                />,
            formatExtraData: { exact: matchExact, search: tableSearchTerm },
            sort: true,
            sortCaret: sortCaret,
            headerFormatter: (column: any, colIndex: number, components: any) => {
                return (
                    <div className="d-flex align-items-center">
                        {column.text}
                        {components.sortElement}
                    </div>
                )
            },
            headerClasses: "no-wrap"
        },
        {
            dataField: "TicketType",
            text: "Ticket Type",
            formatter: (cell: any, row: any, rowIndex: number, { exact, search }: { exact: boolean, search: string }) =>
                <Highlighter
                    highlightClassName="elm-blue-highlight"
                    searchWords={exact ? [search] : splitString(search)} textToHighlight={cell || ""}
                />,
            formatExtraData: { exact: matchExact, search: tableSearchTerm },
            sort: true,
            sortCaret: sortCaret,
            headerFormatter: (column: any, colIndex: number, components: any) => {
                return (
                    <div className="d-flex align-items-center">
                        {column.text}
                        {components.sortElement}
                    </div>
                )
            },
            headerClasses: "no-wrap"
        },
        {
            dataField: "Address",
            text: "Address",
            formatter: (cell: string, row: any, rowIndex: number, { exact, search }: { exact: boolean, search: string }) => (
                <div className="d-flex flex-column">
                    <Highlighter
                        highlightClassName="elm-blue-highlight"
                        searchWords={exact ? [search] : splitString(search)} textToHighlight={cell || ""}
                    />
                    <Highlighter
                        highlightClassName="elm-blue-highlight"
                        searchWords={exact ? [search] : splitString(search)}
                        textToHighlight={`${row.City ? row.City + "," : ""} ${row.State || ""}`}
                    />
                </div>
            ),
            formatExtraData: { exact: matchExact, search: tableSearchTerm },
            sort: true,
            sortCaret: sortCaret,
            headerFormatter: (column: any, colIndex: number, components: any) => {
                return (
                    <div className="d-flex align-items-center">
                        {column.text}
                        {components.sortElement}
                    </div>
                )
            },
            headerClasses: "no-wrap"
        },
        {
            dataField: "ImageCount",
            text: "",
            isDummyField: true,
            formatter: (cell: any, row: any) => <ImageCounter ticketId={row.TicketID} />,
            sort: false,
        },
        {
            dataField: "County",
            text: "County",
            formatter: (cell: any, row: any, rowIndex: number, { exact, search }: { exact: boolean, search: string }) => <Highlighter
                highlightClassName="elm-blue-highlight"
                searchWords={exact ? [search] : splitString(search)}
                textToHighlight={cell || ""}
            />,
            formatExtraData: { exact: matchExact, search: tableSearchTerm },
            sort: true,
            sortCaret: sortCaret,
            headerFormatter: (column: any, colIndex: number, components: any) => {
                return (
                    <div className="d-flex align-items-center">
                        {column.text}
                        {components.sortElement}
                    </div>
                )
            },
            headerClasses: "no-wrap"
        },
        {
            dataField: "ELMArea",
            text: "Area",
            formatter: (cell: string, row: any, rowIndex: number, { exact, search }: { exact: boolean, search: string }) =>
                <Highlighter
                    highlightClassName="elm-blue-highlight"
                    searchWords={exact ? [search] : splitString(search)} textToHighlight={cell || ""}
                />,
            formatExtraData: { exact: matchExact, search: tableSearchTerm },
            sort: true,
            sortCaret: sortCaret,
            headerFormatter: (column: any, colIndex: number, components: any) => {
                return (
                    <div className="d-flex align-items-center">
                        {column.text}
                        {components.sortElement}
                    </div>
                )
            },
            headerClasses: "no-wrap"
        },
        {
            dataField: "Excavator",
            text: "Excavator",
            formatter: (cell: string, row: any, rowIndex: number, { exact, search }: { exact: boolean, search: string }) =>
                <Highlighter
                    highlightClassName="elm-blue-highlight"
                    searchWords={exact ? [search] : splitString(search)} textToHighlight={cell || ""}
                />,
            formatExtraData: { exact: matchExact, search: tableSearchTerm },
            sort: true,
            sortCaret: sortCaret,
            headerFormatter: (column: any, colIndex: number, components: any) => {
                return (
                    <div className="d-flex align-items-center">
                        {column.text}
                        {components.sortElement}
                    </div>
                )
            },
            headerClasses: "no-wrap"
        },
        {
            dataField: "ProfitCenter",
            text: "Profit Center",
            formatter: (cell: string, row: any, rowIndex: number, { exact, search }: { exact: boolean, search: string }) =>
                <Highlighter
                    highlightClassName="elm-blue-highlight"
                    searchWords={exact ? [search] : splitString(search)} textToHighlight={cell || ""}
                />,
            formatExtraData: { exact: matchExact, search: tableSearchTerm },
            sort: true,
            sortCaret: sortCaret,
            headerFormatter: (column: any, colIndex: number, components: any) => {
                return (
                    <div className="d-flex align-items-center">
                        {column.text}
                        {components.sortElement}
                    </div>
                )
            },
            headerClasses: "no-wrap"
        }
    ]

    const handleScroll = (e: any) => {
        const el: HTMLElement = e.target;
        //? 400px above the bottom of the scrollbar it will load more
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 400) {
            setRenderedAmount(renderedAmount + 250);
        }
    }

    const handleResultsChange = (newResults: any, callback: any = () => null) => {
        //console.log("Setting filtered results");
        setFilteredResults(newResults);
        callback();
    }

    const handleSearchTermChange = (newSearchTerm: string) => {
        setTableSearchTerm(newSearchTerm);
    }

    const selectTicketFromQuickList = (newDetails: any) => {
        history.push("/coop/ticket-search?ticketid=" + newDetails.TicketID)
        ticketSearchRef?.current.showDetails(newDetails);
    }

    const clearDetails = () => { ticketSearchRef?.current.hideDetails(); }

    React.useEffect(() => {
        let ticketId: string = query.get("ticketid") || "";
        if (ticketId) {
            axios.get(process.env.REACT_APP_API_URL + `/api/TicketQuery/GetTicketDetail?ticketId=${ticketId}`, AxiosConfig.configValue("min"))
                .then((res: any) => {
                    AxiosConfig.checkResponse(res);
                    ticketSearchRef?.current.showDetails(res.data)
                })
                .catch((err: any) => {
                    //console.log(err);
                })
        }
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [])

    React.useEffect(() => {
        //? Sets up logic for infinite loading table
        let main: any = document.querySelector(".layout-pane");
        main.addEventListener("scroll", handleScroll);
        return () => { main.removeEventListener("scroll", handleScroll); }
        // eslint-disable-next-line 
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [renderedAmount])

    return (
        <div className="ticket-search-double-panel-wrapper main-content col-sm px-1" id="ticket-search-wrapper">
            <Header
                resultsChanged={handleResultsChange}
                searchTermChanged={handleSearchTermChange}
                selectFromQuickList={selectTicketFromQuickList}
                clearDetails={clearDetails}
                userId={userId}
                filteredLength={filteredResults.length}
                useExact={matchExact}
                toggleExact={() => setMatchExact(!matchExact)}
            />
            <DoublePanel
                manual
                startWithLoader={false}
                url=""
                ref={ticketSearchRef}
                wrapperStyles={{ height: "calc(100vh - 48px - 83px)", marginTop: 67, overflowY: "hidden", paddingBottom: 20 }}
                keyField="TicketID"
                columns={columns}
                columnToggle
                columnToggleTarget="TicketSearchColumns"
                clickCallback={(row: any) => history.push("/coop/ticket-search?ticketid=" + row.TicketID)}
                data={filteredResults.slice(0, renderedAmount)}
                unclosableColumns={["ImageCount", "TicketNum"]}
                hidden={props.TicketSearchColumns || []}
                // Header={null}
                // detailWrapperClassName="double-panel-background"
                DetailPanel={({ details, handleClose, toggleVertical, isVertical }: { details: any, handleClose: any, toggleVertical: any, isVertical: boolean }) => {
                    return <Details userId={props.userId} toggleVertical={toggleVertical} isVertical={isVertical} details={details} handleClose={handleClose} />
                }}
            />
        </div>
    );
}

const mapStateToProps = (state: AppState) => ({ userId: state.user.userId, TicketSearchColumns: state.user.UserSettings?.TicketSearchColumns });

export default connect(mapStateToProps)(TicketSearch);